define('views/shared/grid/grid',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/grid/grid.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        tagName  : 'div',
        template : _.template(Template),
        isRender : true,
        events   : {},

        initialize: function(options){
            options = options || {};

            // TODO: Add generic grid classes and options to allow for a base grid with extendible options

            this.grid = options.grid;

            this.elementName = options.elementName;
            
            BaseView.prototype.initialize(this);
        },

        render: function(){

            this.$el.addClass(this.grid.class).html(this.template());

            this.addGridItems();

            return this;
        },

        addGridItems: function(){
            var that = this;

            if(_.isArray(this.grid.items)){

                this.grid.items.forEach(function(item, index){

                    // TODO: Make the HTML list items their own generic component
                    var header = item.header,
                        graphic = pf.getContent(item.graphic),
                        copy = item.copy,
                        html= [
                            '<li class="HIW-list-item">',
                                '<h3 class="HIW-list-item__title text-brand">' + header + '</h3>',
                                
                                '<div class="HIW-list-item__graphic text-brand">',
                                    graphic,
                                '</div>',

                                '<div class="HIW-list-item__copy">' + copy + '</div>',
                            '</li>'
                        ].join('');

                    that.$el.find('ul').append(html);
                });

            }

        },
       
        close: function(){}
    });
});
